import {
  Entity,
  PrimaryKey,
  Property,
  Unique,
  OneToMany,
  Collection,
} from '@mikro-orm/core';
import { ProgramType } from './program-type.entity';
import { UserProgram } from './user-program.entity';

@Entity({ tableName: 'programs' })
export class Program {
  @PrimaryKey()
  id!: number;

  @Property({ type: 'varchar', length: 150 })
  @Unique()
  name!: string;

  @Property({ type: 'varchar', length: 150, nullable: true })
  slug?: string | null;

  @OneToMany(() => ProgramType, (t) => t.program)
  types = new Collection<ProgramType>(this);

  @OneToMany(() => UserProgram, (up) => up.program)
  userPrograms = new Collection<UserProgram>(this);

  @Property({ type: 'datetime' })
  created_at: Date = new Date();

  @Property({ type: 'datetime', onUpdate: () => new Date() })
  updated_at?: Date = new Date();

  @Property({ type: 'datetime', nullable: true })
  deleted_at?: Date | null = null;
}
